(function (root, factory) {
  const story = factory();
  if (typeof module === "object" && module.exports) module.exports = story;
  if (root) root.LafiaConceptStory = story;
})(typeof window === "undefined" ? null : window, function () {
  "use strict";

  const FORMAT = "lafia-story-v1";
  // v2: 공주 이야기 디자인(가운데 제목, 대사, 장면 한 줄, 두 갈래 선택, 마지막 질문). v1 글은 그대로 v1로 보인다.
  const FORMAT_V2 = "lafia-story-v2";
  const LANG = { ko: "kr", kr: "kr", en: "en", ja: "jp", jp: "jp" };
  const DIALOG_MARKS = { ko: ["\"", "\""], en: ["“", "”"], ja: ["「", "」"] };

  function select(description, requested) {
    const desc = description && typeof description === "object" ? description : {};
    const wanted = LANG[requested] || "kr";
    const hasOwn = Object.prototype.hasOwnProperty.call(desc.storyLine || {}, wanted);
    const selected = hasOwn ? wanted : "kr";
    const get = (field) => String(desc[field] && desc[field][selected] || "");
    const format = desc.storyFormat && desc.storyFormat[selected];
    return {
      mode: format === FORMAT ? "v1" : format === FORMAT_V2 ? "v2" : "legacy",
      locale: selected === "jp" ? "ja" : selected === "kr" ? "ko" : "en",
      title: get("title"),
      subTitle: get("subTitle"),
      body: get("storyLine"),
      closing: get("closing"),
      image: storyImage(desc.storyImage),
    };
  }

  // 본문 삽화 주소는 이 사이트 안의 경로만 받는다.
  function storyImage(value) {
    return typeof value === "string" && /^\/[^/\\]/.test(value) ? value : "";
  }

  function parse(body) {
    const input = String(body || "").replace(/\r\n?/g, "\n");
    if (input.length > 32000) throw new Error("story-too-long");
    const paragraphs = input.split(/\n\s*\n/).map((part) => part.trim()).filter(Boolean);
    if (paragraphs.length > 300) throw new Error("too-many-paragraphs");
    return paragraphs.map((paragraph) => {
      const lines = paragraph.split("\n");
      const quoted = lines.every((line) => /^> /.test(line));
      const content = quoted ? lines.map((line) => line.slice(2)).join("\n") : paragraph;
      const parts = [];
      let cursor = 0;
      const marker = /\*\*/g;
      let strong = false;
      let match;
      while ((match = marker.exec(content))) {
        if (match.index > 0 && content[match.index - 1] === "\\") continue;
        if (match.index > cursor) parts.push({ text: content.slice(cursor, match.index), strong });
        strong = !strong;
        cursor = match.index + 2;
      }
      if (strong) throw new Error("unclosed-emphasis");
      if (cursor < content.length) parts.push({ text: content.slice(cursor), strong: false });
      return { quoted, parts };
    });
  }

  function plainText(body) {
    try {
      return parse(body).map((block) => block.parts.map((part) => part.text.replace(/\\\*\*/g, "**")).join("")).join("\n\n");
    } catch {
      return String(body || "");
    }
  }

  function appendText(target, text) {
    const lines = text.replace(/\\\*\*/g, "**").split("\n");
    lines.forEach((line, index) => {
      if (index) target.appendChild(document.createElement("br"));
      target.appendChild(document.createTextNode(line));
    });
  }

  // 한국어에서 함께 읽히는 말(관형어+명사, 본용언+보조용언, 짧은 끝말)이 줄 끝에서 갈라지지 않게 줄바꿈 없는 공백으로 묶는다.
  const NB = " ";
  const GLUE = [
    [/(^|[\s"'])(그|이|저|그런|이런|저런|어떤|모든|한|두|세|네|몇|온|새|옛|첫) (?=\S)/g, (m, a, b) => a + b + NB],
    [/(\S에) (들\S*)/g, "$1" + NB + "$2"],
    [/(\S) (수|적|줄|것|뿐)([이은도을가]?)(?=[ .,?!]|$)/g, "$1" + NB + "$2$3"],
    [/((?:수|적|줄|것)[이은도을가]?) ((?:있|없)\S*)/g, "$1" + NB + "$2"],
    [/(\S*[아어여해워와게지고]) ((?:주|줘|보|싶|않|있|없|버리|놓|두|말|하)\S*)/g, "$1" + NB + "$2"],
    [/(\S야만?) ((?:한다|하다|할까|했다|하지|해|합니다)\S*)/g, "$1" + NB + "$2"],
    [/(^|\s)(\S+) (\S+[.?!]["”']?)(?=\s|$)/g, (m, a, b, c) => (b + c).length <= 10 ? a + b + NB + c : m],
  ];

  function glue(text) {
    return GLUE.reduce((out, [pattern, to]) => out.replace(pattern, to), text);
  }

  // v2 본문 표시 규칙: 빈 줄 = 문단, "> " = 대사, "## " = 장면 한 줄, "- [말머리] 글" = 두 갈래 선택,
  // 마지막 문단의 마지막 줄이 물음표로 끝나면 마지막 질문(앞 줄은 질문 앞 문장). **강조**는 문단에서는 밑줄, 선택에서는 결과.
  function parseV2(body) {
    // 선택 줄은 빈 줄 없이 이어 써도 한 줄이 한 갈래다(이어 쓰면 둘째 줄이 첫 갈래 본문에 붙어 '- ['가 그대로 보였다).
    const split = String(body || "").replace(/\r\n?/g, "\n").replace(/\n(?=- \[[^\]\n]+\])/g, "\n\n");
    return parse(split).reduce((blocks, block, index, all) => {
      const raw = block.parts.map((part) => (part.strong ? "**" + part.text + "**" : part.text)).join("");
      const choice = !block.quoted && raw.match(/^- \[([^\]\n]+)\] *([\s\S]+)$/);
      const scene = !block.quoted && raw.match(/^## +([\s\S]+)$/);
      if (block.quoted) blocks.push({ type: "dialog", parts: block.parts });
      else if (choice) {
        const last = blocks[blocks.length - 1];
        const item = { label: choice[1].trim(), parts: parse(choice[2])[0].parts };
        if (last && last.type === "choices") last.items.push(item);
        else blocks.push({ type: "choices", items: [item] });
      } else if (scene) blocks.push({ type: "scene", parts: parse(scene[1])[0].parts });
      else if (index === all.length - 1 && /[?？]["”」']?(\*\*)?$/.test(raw)) {
        const lines = raw.split("\n");
        const lead = lines.slice(0, -1).join("\n");
        blocks.push({ type: "finale", lead: lead ? parse(lead)[0].parts : [], question: parse(lines[lines.length - 1])[0].parts });
      } else blocks.push({ type: "paragraph", parts: block.parts });
      return blocks;
    }, []);
  }

  function element(tag, className, parent) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (parent) parent.appendChild(node);
    return node;
  }

  // 글 안의 "따옴표 말"은 색으로 구분하고, 한국어면 붙어 다니는 말을 묶는다.
  function appendInline(target, parts, locale) {
    parts.forEach((part) => {
      const holder = part.strong ? element("strong", "", target) : target;
      const text = part.text.replace(/\\\*\*/g, "**");
      const lines = (locale === "ko" ? glue(text) : text).split("\n");
      lines.forEach((line, index) => {
        if (index) holder.appendChild(document.createElement("br"));
        line.split(/("[^"\n]+"|“[^”\n]+”|「[^」\n]+」)/).forEach((piece, at) => {
          if (!piece) return;
          if (at % 2) element("span", "lafia-story__said", holder).textContent = piece;
          else holder.appendChild(document.createTextNode(piece));
        });
      });
    });
  }

  function renderV2(target, selected) {
    const { locale } = selected;
    const inline = (text) => [{ text, strong: false }];
    // 제목·부제는 본문과 떨어진 금테 카드에 한 덩어리로 둔다.
    if (selected.title || selected.subTitle) {
      const head = element("header", "lafia-story__head", target);
      const label = element("span", "lafia-story__label", head);
      label.textContent = "PRINCESS STORY";
      label.setAttribute("aria-hidden", "true");
      if (selected.title) {
        const title = element("h2", "lafia-story__title", head);
        title.id = "storyTitle";
        appendInline(title, inline(selected.title), locale);
      }
      if (selected.subTitle) appendInline(element("p", "lafia-story__subtitle", head), inline(selected.subTitle), locale);
    }
    const card = element("div", "lafia-story__card", target);
    const body = element("div", "lafia-story__body", card);
    let blocks;
    try { blocks = parseV2(selected.body); }
    catch (error) {
      console.error("Invalid concept story format", error);
      blocks = [{ type: "paragraph", parts: inline(selected.body) }];
    }
    // 삽화는 첫 장면 한 줄 바로 밑. 장면 줄이 없으면 마지막 질문 앞, 그것도 없으면 본문 끝.
    const sceneAt = blocks.findIndex((block) => block.type === "scene");
    const finaleAt = blocks.findIndex((block) => block.type === "finale");
    const artAt = sceneAt >= 0 ? sceneAt + 1 : finaleAt >= 0 ? finaleAt : blocks.length;
    const art = () => {
      if (!selected.image) return;
      const figure = element("figure", "lafia-story__figure", body);
      const image = element("img", "lafia-story__art", figure);
      // 삽화가 안 오면 빈 분홍 칸을 남기지 않는다. 뜻은 위 장면 줄이 이미 전하니 삽화는 장식이다(alt를 비워 낭독기가 같은 줄을 두 번 읽지 않게).
      image.onerror = () => figure.remove();
      image.src = selected.image;
      image.alt = "";
      image.width = 1536;
      image.height = 960;
      image.loading = "lazy";
      image.decoding = "async";
    };
    blocks.forEach((block, index) => {
      if (index === artAt) art();
      if (block.type === "paragraph") appendInline(element("p", "lafia-story__paragraph", body), block.parts, locale);
      else if (block.type === "dialog") {
        const [open, close] = DIALOG_MARKS[locale] || DIALOG_MARKS.en;
        const parts = [{ text: open, strong: false }, ...block.parts, { text: close, strong: false }];
        appendInline(element("blockquote", "lafia-story__dialog", body), parts, locale);
      } else if (block.type === "scene") appendInline(element("p", "lafia-story__scene", body), block.parts, locale);
      else if (block.type === "finale") {
        const finale = element("div", "lafia-story__finale", body);
        if (block.lead.length) appendInline(element("p", "lafia-story__finale-lead", finale), block.lead, locale);
        appendInline(element("p", "lafia-story__question", finale), block.question, locale);
      } else {
        const group = element("div", "lafia-story__choices", body);
        block.items.forEach((item) => {
          const choice = element("div", "lafia-story__choice", group);
          element("p", "lafia-story__choice-label", choice).textContent = item.label;
          appendInline(element("p", "lafia-story__choice-text", choice), item.parts, locale);
        });
      }
    });
    if (artAt >= blocks.length) art();
    if (selected.closing) appendInline(element("p", "lafia-story__closing", card), inline(selected.closing), locale);
  }

  function render(target, selected) {
    if (!target) return;
    target.replaceChildren();
    if (!selected || (selected.mode !== "v1" && selected.mode !== "v2") || !selected.body.trim()) {
      target.hidden = true;
      return;
    }
    target.hidden = false;
    target.classList.add("lafia-story");
    target.classList.toggle("lafia-story--v2", selected.mode === "v2");
    target.lang = selected.locale;
    if (selected.mode === "v2") {
      renderV2(target, selected);
      return;
    }
    if (selected.title) {
      const title = document.createElement("h2");
      title.className = "lafia-story__title";
      title.id = "storyTitle";
      title.textContent = selected.title;
      target.appendChild(title);
    }
    if (selected.subTitle) {
      const subtitle = document.createElement("p");
      subtitle.className = "lafia-story__subtitle";
      subtitle.textContent = selected.subTitle;
      target.appendChild(subtitle);
    }
    const body = document.createElement("div");
    body.className = "lafia-story__body";
    let blocks;
    try { blocks = parse(selected.body); }
    catch (error) {
      console.error("Invalid concept story format", error);
      blocks = [{ quoted: false, parts: [{ text: selected.body, strong: false }] }];
    }
    blocks.forEach((block) => {
      const paragraph = document.createElement(block.quoted ? "blockquote" : "p");
      paragraph.className = block.quoted ? "lafia-story__quote" : "lafia-story__paragraph";
      if (!block.quoted && block.parts.length && block.parts.every((part) => part.strong || !part.text.trim())) {
        paragraph.classList.add("lafia-story__statement");
      } else if (!block.quoted && block.parts[0]?.strong && /^\n/.test(block.parts[1]?.text || "")) {
        paragraph.classList.add("lafia-story__lead");
      }
      block.parts.forEach((part) => {
        const node = part.strong ? document.createElement("strong") : paragraph;
        appendText(node, part.text);
        if (part.strong) paragraph.appendChild(node);
      });
      body.appendChild(paragraph);
    });
    target.appendChild(body);
    if (selected.closing) {
      const closing = document.createElement("p");
      closing.className = "lafia-story__closing";
      closing.textContent = selected.closing;
      target.appendChild(closing);
    }
  }

  return { FORMAT, FORMAT_V2, select, parse, parseV2, glue, plainText, render };
});
